import { LitElement, html, css } from '~/lib/bn-lit-element';
import { sharedStyles } from '../styles/shared-styles';

class BnWell extends LitElement {
  static get styles() {
    return [sharedStyles, css`
      :host > div {
        padding: 1em;
        background-color: var(--background);
        border: 1px solid var(--gray-40);
        border-radius: .3em;
        box-shadow: 0 0 3px var(--gray-50) inset;
      }
      :host([blue]) > div {
        background-color: var(--blue-40);
        border: 1px dashed var(--blue-60);
        color: var(--blue-60);
      }
    `];
  }

  render() {
    return html`
      <div><slot></slot></div>
    `;
  }
}

window.customElements.define('bn-well', BnWell);
